import { getTranslationOrInnerText } from './get-translation-or-inner-text';
import { isHTMLElement } from './is-html-element';

/**
 * Locates the first heading element (h1, h2, h3, h4, h5, or h6) within the given
 * HTML element and retrieves its translation key or inner text. If no heading
 * element is found, it returns null.
 *
 *
 * @param element - The HTML element to search within.
 * @returns The translation key from the heading element's `data-key` attribute or
 *         the inner text of the heading element, or null if no heading element is found.
 *
 */
export const getElementHeadingValue = element => {
  const titleElement = element.querySelector('h1, h2, h3, h4, h5, h6');
  if (isHTMLElement(titleElement)) {
    return getTranslationOrInnerText(titleElement);
  }
  return null;
};